<template>
  <div class="choose-store">
    <el-cascader
      v-model="storeIdList"
      placeholder="请选择店铺"
      :options="shopTreeData"
      :props="shopCascaderProps"
      clearable
      collapse-tags
      :filterable="true"
      :show-all-levels="false"
      @change="chooseStoreChange"
    >
    </el-cascader>
  </div>
</template>
<script>
import { api_getConfig } from "@/api/common";
export default {
  name: 'ChooseStore',
  props: {
    multiple: {
      type: Boolean,
      default() {
        return false
      },
    },
    value: {
      default() {
        return null
      },
    },
  },
  data() {
    return {
      storeIdList: [],
      shopTreeData: [], // 店铺级联框树形数据
      shopCascaderProps: {
        multiple: this.multiple,
        value: "id",
        label: "name",
        emitPath: false,
      }, // 店铺级联框配置项 
    }
  },
  created () {
    this.storeIdList = this.value
    this.getShopTreeData() // 获取店铺级联框数据
  },
  methods: {
    // 获取店铺级联框数据
    async getShopTreeData() {
      const res = await api_getConfig('storeThreeLevel')
      this.shopTreeData = res.storeThreeLevel
    },
    chooseStoreChange (value) {
      this.$emit('getChooseStoreValue', value)
    }
  },
  computed: {
  },
  components: {
  },
  watch: {
    value (newValue) {
      this.storeIdList = newValue
    }
  }
}
</script>
<style lang="scss" scoped>
.choose-store{
  ::v-deep{
    .el-cascader{
      width: 100% !important;
      .el-input.is-focus+.el-cascader__tags{
        input{
          background: #fff;
        }
      }
      .el-cascader__search-input{
        background: #F2F3F5;
        border: 0;
      }
    }
  }
}
</style>
